export const DATE_AND_TIME_WITH_MONTH_FORMAT = 'MMM d, yyyy p';
export const DATE_FORMAT_LONG = 'dddd - MMM Do, YYYY';
export const DATE_FORMAT_SHORT = 'M/D/YY';
export const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
export const DAY_AND_DATE_FORMAT = 'dddd MMM Do';
export const DAY_AND_DATE_WITH_YEAR_FORMAT = 'dddd MMMM Do, YYYY';
export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';

export const PROJECT_RANGE_DATE_FORMAT = 'MM/DD/YYYY';

export const STANDARD_TIME_FORMAT = 'hh:mm A';
export const STANDARD_TIME_FORMAT_WITH_TZ = `${STANDARD_TIME_FORMAT} z`;
export const TIME_FORMAT_SHORT = 'h:mm a';

// date-fns formatting
export const DAY_AND_DATE_WITH_YEAR_FORMAT_FNS = 'EEEE MMMM do, yyyy';
export const DAY_AND_DATE_WITH_YEAR_WITH_DASH_FORMAT_FNS =
  'EEEE - MMMM do, yyyy';
export const DAY_AND_DATE_FORMAT_FNS = 'EEEE MMM do';
export const DAY_AND_DATE_FORMAT_FNS_SHORT = 'E, MMM do';
export const DATE_FNS_FORMAT_SHORT = 'M/d/yy';
export const DATE_FNS_FORMAT_FULL_YEAR = 'M/d/yyyy';
export const PROJECT_RANGE_DATE_FORMAT_FNS = 'MM/dd/yyyy';
export const ISO_DATE_FORMAT_FNS = 'yyyy-MM-dd';
export const ISO_DATE_TIME_UTC_FORMAT_FNS = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const TIME_FORMAT_FNS = 'hh:mm';
export const STANDARD_TIME_FORMAT_FNS = 'hh:mm aa';
export const STANDARD_TIME_FORMAT_WITH_TZ_FNS = `${STANDARD_TIME_FORMAT_FNS} zzz`;
export const TIME_FNS_FORMAT_SHORT = 'h:mm aaa';
export const TIME_FNS_FORMAT_SHORT_ALL_CAPS = 'h:mm a';
export const TIME_WITH_ZONE_FORMAT_SHORT = `${DATE_FNS_FORMAT_SHORT} '@' ${TIME_FNS_FORMAT_SHORT} zzz`;
export const DAY_AND_DATE_WITH_YEAR_AND_TIME = `EEEE - MMMM do, yyyy @ ${TIME_FNS_FORMAT_SHORT}`;
export const DAY_AND_DATE_WITH_YEAR_AND_TIME_WITH_TZ = `EEEE - MMMM do, yyyy @ ${TIME_FNS_FORMAT_SHORT} zzz`;
